module.exports = __webpack_public_path__ + "img/Enterprise.0a20074c.jpg";